<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <Index :modal_cadastro="modal_cadastro" :perfis="perfis" />
        </div>
    </div>
</template>

<script lang="ts">
    import Index from "./_Index.vue"
    import { Options, Vue } from "vue-class-component";
    import { namespace } from 'vuex-class';
    const authStore = namespace('auth');

    @Options({
        name: "Espaco",
        components: { Index },
    })
    export default class Espaco extends Vue {
        @authStore.Getter
        public perfis!: any

        public modal_cadastro;

        created() {
            this.modal_cadastro = 'kt_cadastrar_espaco';
        }
    }
</script>
